/** Mirrors finance InvoiceDirection / InvoiceStatus. */
export const INVOICE_DIRECTIONS = [
  { value: 'receivable', label: 'Receivable (AR)' },
  { value: 'payable', label: 'Payable (AP)' },
] as const;

export type InvoiceDirection = (typeof INVOICE_DIRECTIONS)[number]['value'];

export const INVOICE_STATUSES = [
  { value: 'draft', label: 'Draft' },
  { value: 'issued', label: 'Issued' },
  { value: 'paid', label: 'Paid' },
  { value: 'void', label: 'Void' },
] as const;

export type InvoiceStatus = (typeof INVOICE_STATUSES)[number]['value'];

/** Statuses the invoice form may set. Issued / Paid only through the Issue /
 *  Mark paid actions, which freeze the PDF, post the ledger and pay commission
 *  (BE ADR-103). */
export const INVOICE_FORM_STATUSES = INVOICE_STATUSES.filter(
  (s) => s.value === 'draft' || s.value === 'void',
);

export const directionLabel = (s: string): string =>
  INVOICE_DIRECTIONS.find((x) => x.value === s)?.label ?? s;

export const invoiceStatusLabel = (s: string): string =>
  INVOICE_STATUSES.find((x) => x.value === s)?.label ?? s;

export function invoiceStatusVariant(s: string): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (s === 'paid') return 'default';
  if (s === 'issued') return 'secondary';
  if (s === 'void') return 'destructive';
  return 'outline'; // draft
}
